import * as React from 'react';

import { Icon } from '@ao-internal/components-react';

import { ChatMessageTypes, ChatMessageTypesClassMap } from '../../store';

export interface PageUpdateMessageContent {
	pageUrl: string;
}

export interface PageUpdateMessageProps {
	pageData: PageUpdateMessageContent;
}

export const dataTestId = `${
	ChatMessageTypesClassMap[ChatMessageTypes.PageUpdate]
}-message`;

export const PageUpdateMessage: React.FC<PageUpdateMessageProps> = ({
	pageData,
}) => {
	return (
		<div data-testid={dataTestId} className="mx-2 mb-2">
			<div
				data-testid={dataTestId}
				className="bg-lightblue flex p-3 space-x-2 rounded"
			>
				<div>
					<Icon className="text-cta-action" icon="product-info" size="2x" />
				</div>
				<div className="flex-grow">
					<span className="text-title-sm block mb-1">Page</span>
					<a
						className="text-link line-clamp-2 text-xs break-all"
						href={pageData.pageUrl}
						target="_blank"
						rel="noreferrer noopener"
					>
						{pageData.pageUrl}
					</a>
				</div>
			</div>
		</div>
	);
};

export default PageUpdateMessage;
